

const configVars = {
    domain: 'login.nextcloud.aero',
    redirectSignIn: [process.env.REACT_APP_REDIRECT_SIGN_IN],
    redirectSignOut: [process.env.REACT_APP_REDIRECT_SIGN_OUT],

    region: 'us-west-2',
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    identityPoolId: '',
    cookieStorageDomain: '.nextcloud.aero',
};


const setConfig = (userPoolClientId) => {
    return {
        Auth: {
            Cognito: {
                userPoolId: configVars.userPoolId,
                userPoolClientId: userPoolClientId,
                identityPoolId: '',
                allowGuestAccess: false,
                loginWith: {
                    oauth: {
                        domain: configVars.domain,
                        scopes: [
                            'phone',
                            'email',
                            'profile',
                            'openid',
                            'aws.cognito.signin.user.admin',
                        ],
                        redirectSignIn: configVars.redirectSignIn,
                        redirectSignOut: configVars.redirectSignOut,
                        responseType: 'token',
                    },
                },
            },
        },
    }
}

export default setConfig;
